// Which icon a list's circle shows, picked from the words in its name — so it
// needs no stored setting, is the same on every device, and follows a rename.
// First match wins, so an entry sits above any entry whose words it would lose
// to ("Dinner Party" is dinner, not party; "Camping Trip" is camping, not trip).
// Broad words like "home" sit near the bottom, so "Home groceries" stays groceries.
// Files are in app/public/images/lists/; a name that matches nothing gets `list`.
const ICONS: [string, string[]][] = [
    ['baby-hospital-bag', ['baby', 'babies', 'newborn']],
    ['new-puppy', ['puppy', 'puppies', 'dog', 'pet']],
    ['wedding-day', ['wedding']],
    ['backyard-bbq', ['bbq', 'barbecue', 'grill']],
    ['dinner-party', ['dinner']],
    ['christmas-tree', ['christmas', 'xmas']],
    ['horror-movies', ['horror', 'scary', 'spooky', 'halloween']],
    ['tv', ['tv', 'series']],
    ['movies', ['movie', 'film', 'cinema', 'watchlist']],
    ['book', ['book', 'novel', 'reading', 'library']],
    ['camera', ['photo', 'camera']],
    ['music', ['music', 'album', 'song', 'playlist', 'concert']],
    ['dice', ['board game', 'game night', 'card game', 'dice']],
    ['controller', ['game', 'gaming', 'console']],
    ['birthday-party', ['birthday', 'party', 'parties']],
    ['picnic', ['picnic']],
    ['camping-trip', ['camping', 'camp']],
    ['beach-day', ['beach', 'pool']],
    ['day-hike', ['hike', 'hiking']],
    ['road-trip', ['road']],
    ['business-trip', ['business', 'work']],
    ['travel-checklist', ['travel', 'trip', 'packing', 'vacation', 'holiday']],
    ['moving-day', ['moving', 'move']],
    ['spring-cleaning', ['cleaning', 'chore']],
    ['back-to-school', ['school', 'college']],
    ['gym-bag', ['gym', 'workout', 'fitness']],
    ['first-aid-kit', ['first aid', 'medicine', 'pharmacy']],
    ['meal-prep', ['meal', 'recipe', 'cooking']],
    ['weekly-groceries', ['grocery', 'groceries', 'shopping']],
    ['first-apartment', ['apartment', 'house', 'home']],
    ['todo', ['to-do', 'todo', 'to do', 'task']],
]

// Whole words only, with an optional plural "s" ("trips", "tasks").
const RULES = ICONS.map(([icon, words]) => ({ icon, re: new RegExp(`\\b(${words.join('|')})s?\\b`, 'i') }))

// The key alone, for the New List wizard to preselect its guess.
export const iconKeyForName = (name: string): string =>
    RULES.find(r => r.re.test(name))?.icon ?? 'list'

export const iconForName = (name: string): string => `/images/lists/${iconKeyForName(name)}.svg`
